/*
 * Shop by quantity: minimum order, and unit price at that quantity.
 *
 * Shopify's filters work on the variant price, which for these products is the
 * price at one minimum order — not what the buyer pays at their quantity, and
 * no help at all with whether they can order the thing in the first place. A
 * product with a 500 minimum is not a candidate for someone buying 100, and
 * quoting them its price at 100 is a number they can never pay.
 *
 * Both facts ride on every card, so the filter reads them there. It filters
 * the page in front of the customer, not the whole collection — the count says
 * so, rather than letting anyone think page 3 was searched.
 */
(function () {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  function start() {
    var facet = document.querySelector('[data-sb-facet]');
    if (!facet) return;

    var maxInput = facet.querySelector('[data-sb-facet-max]');
    var maxLabel = facet.querySelector('[data-sb-facet-max-label]');
    var moqInput = facet.querySelector('[data-sb-facet-moq]');
    var countEl = facet.querySelector('[data-sb-facet-count]');
    var clearBtn = facet.querySelector('[data-sb-facet-clear]');

    var quantity = 250;
    var priceActive = false;
    var fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' });

    function cards() {
      return [].slice.call(document.querySelectorAll('.product-item'));
    }

    function data(card) {
      return card.querySelector('[data-sb-ladder]');
    }

    function moqOf(card) {
      var el = data(card);
      var moq = el && parseInt(el.dataset.sbMoq, 10);
      return moq > 0 ? moq : null;
    }

    /* The band that applies at this quantity: the deepest break at or below it. */
    function unitCentsAt(card, qty) {
      var el = data(card);
      if (!el || !el.dataset.sbLadder) return null;
      var best = null;
      el.dataset.sbLadder.split(',').forEach(function (pair) {
        var parts = pair.split(':');
        var min = parseInt(parts[0], 10);
        var cents = parseInt(parts[1], 10);
        if (qty >= min && (best === null || min > best.min)) best = { min: min, cents: cents };
      });
      return best ? best.cents : null;
    }

    function apply() {
      var max = parseInt(maxInput.value, 10);
      maxLabel.textContent = fmt.format(max / 100);
      var moqActive = !!(moqInput && moqInput.checked);

      var judged = 0;
      var shown = 0;

      cards().forEach(function (card) {
        var moq = moqOf(card);
        var cents = unitCentsAt(card, quantity);
        // A card with no ladder carries none of these facts; never hide it on
        // a judgement we could not make.
        if (moq === null && cents === null) {
          card.classList.remove('sb-facet-hidden');
          shown += 1;
          return;
        }
        judged += 1;

        var tooBigAMinimum = moqActive && moq !== null && moq > quantity;
        var tooExpensive = priceActive && cents !== null && cents > max;
        var hide = tooBigAMinimum || tooExpensive;

        card.classList.toggle('sb-facet-hidden', hide);
        if (!hide) shown += 1;
      });

      var filtering = moqActive || priceActive;
      if (!filtering || !judged) {
        countEl.textContent = '';
      } else {
        var what = [];
        if (moqActive) what.push('you can order ' + quantity.toLocaleString() + ' of');
        if (priceActive) what.push('are under ' + fmt.format(max / 100) + ' each at ' + quantity.toLocaleString());
        countEl.textContent = shown + ' of ' + judged + ' on this page ' + what.join(', and ');
      }
      clearBtn.hidden = !filtering;
    }

    facet.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-sb-facet-qty]');
      if (qtyBtn) {
        quantity = parseInt(qtyBtn.dataset.sbFacetQty, 10);
        facet.querySelectorAll('[data-sb-facet-qty]').forEach(function (b) {
          b.classList.toggle('is-active', b === qtyBtn);
        });
        apply();
        return;
      }
      if (e.target.closest('[data-sb-facet-clear]')) {
        priceActive = false;
        if (moqInput) moqInput.checked = false;
        apply();
      }
    });

    if (moqInput) moqInput.addEventListener('change', apply);

    maxInput.addEventListener('input', function () {
      priceActive = true;
      apply();
    });

    apply();
  }
})();
